<template>
  <div class="main c-333">
    <section class="banner banner-leave-message bgs-cover bgp-c d-f ai-c jc-c">
      <h1 class="banner-title c-fff ta-c">Global Dealer <br class="in-h5" />Recruitment Is in Progress</h1>
    </section>
    <div class="content">
      <ul class="step-wrapper d-f jc-sb">
        <li>
          <div class="left-cont">
            <i class="img-box d-b"
              ><img
                width="100%"
                height="100%"
                alt="Register"
                src="data:image/svg+xml,%3Csvg width='64' height='64' viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='%23FFF' fill-rule='nonzero' opacity='.01' d='M0 0h64v64H0z'/%3E%3Cg stroke='%23222' stroke-width='3'%3E%3Cpath d='M20.276 8h22.688c.66 0 1.195.534 1.195 1.192v5.029c0 .656-.535 1.19-1.195 1.19H20.278c-.66 0-1.194-.533-1.195-1.19V9.19c0-.657.535-1.191 1.195-1.191h-.002z'/%3E%3Cpath d='M45.396 11.705l4.99.064a1.186 1.186 0 0 1 1.193 1.172v4.246m0 25.399c0 2.49-.042 5.62-.042 11.178a1.18 1.18 0 0 1-1.194 1.172L13.195 55A1.186 1.186 0 0 1 12 53.827l.043-41.028c0-.648.535-1.171 1.194-1.171l4.947.077' stroke-linecap='round'/%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M53.091 21.587L59 27.546l-18.554 18.71-7.198 1.295 1.286-7.256z'/%3E%3Cpath d='M19.553 25.784h18.553m-18.465 8.892h11.461' stroke-linecap='round'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
            /></i>
            <strong class="d-b fs-28 fw-500 c-222 in-h5">Step1</strong>
            <div class="in-pc">
              <strong class="d-b fs-28 fw-500 in-pc c-333">Register</strong>
              <span class="d-b fs-20 in-pc lh-15">Submit Information</span>
            </div>
          </div>
          <div class="right-icon bgs-cover">
            <div class="in-h5">
              <strong class="d-b fs-28 fw-500">Register</strong>
              <span class="d-b fs-20">Submit Information</span>
            </div>
          </div>
        </li>
        <li>
          <div class="left-cont">
            <i class="img-box d-b"
              ><img
                width="100%"
                height="100%"
                alt="Register"
                src="data:image/svg+xml,%3Csvg width='64' height='64' viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill-opacity='.01' fill='%23FFF' fill-rule='nonzero' d='M0 0h64v64H0z'/%3E%3Cg stroke-linecap='round' transform='translate(8.667 8)' stroke='%23222' stroke-width='3'%3E%3Ccircle stroke-linejoin='round' cx='19.333' cy='10.667' r='10.667'/%3E%3Cpath d='M34.736 18.037a7.53 7.53 0 0 0 6.71-7.49 7.53 7.53 0 0 0-6.715-7.491' stroke-linejoin='round'/%3E%3Cpath d='M0 45.333C0 35.76 7.76 28 17.333 28h4c9.574 0 17.334 7.76 17.334 17.333M34.87 24.307c6.504 1.066 11.604 6.313 12.462 12.896'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
            /></i>
            <strong class="d-b fs-28 fw-500 c-222 in-h5">Step2</strong>
            <div class="in-pc">
              <strong class="d-b fs-28 fw-500 c-333">Review</strong>
              <span class="d-b fs-20 lh-15">You will be contacted within 3 working days after your submission</span>
            </div>
          </div>
          <div class="right-icon bgs-cover">
            <div class="in-h5">
              <strong class="d-b fs-28 fw-500">Review</strong>
              <span class="d-b fs-20">You will be contacted within 3 working days after your submission</span>
            </div>
          </div>
        </li>
        <li>
          <div class="left-cont">
            <i class="img-box d-b"
              ><img
                width="100%"
                height="100%"
                alt="Register"
                src="data:image/svg+xml,%3Csvg width='64' height='64' viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill-opacity='.01' fill='%23FFF' fill-rule='nonzero' d='M0 0h64v64H0z'/%3E%3Cg transform='translate(15.067 31.333)' fill='%23222' fill-rule='nonzero'%3E%3Ccircle cx='2.267' cy='2.267' r='2.267'/%3E%3Ccircle cx='12.933' cy='2.267' r='2.267'/%3E%3Ccircle cx='23.6' cy='2.267' r='2.267'/%3E%3C/g%3E%3Cpath d='M9.333 18.667h37.334c.736 0 1.333.597 1.333 1.333v26.536a1.333 1.333 0 0 1-1.347 1.333l-13.097-.128L28 53.333l-5.556-5.592-13.097.128A1.333 1.333 0 0 1 8 46.536V20c0-.736.597-1.333 1.333-1.333z' stroke='%23222' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M28 10.667h25.333A2.667 2.667 0 0 1 56 13.333v25.334' stroke='%23222' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3C/svg%3E"
            /></i>
            <strong class="d-b fs-28 fw-500 c-222 in-h5">Step3</strong>
            <div class="in-pc">
              <strong class="d-b fs-28 fw-500 c-333">Confirmation</strong>
              <span class="d-b fs-20 lh-15">Discuss and confirm contracts</span>
            </div>
          </div>
          <div class="right-icon bgs-cover">
            <div class="in-h5">
              <strong class="d-b fs-28 fw-500">Confirmation</strong>
              <span class="d-b fs-20">Discuss and confirm contracts</span>
            </div>
          </div>
        </li>
        <li>
          <div class="left-cont">
            <i class="img-box d-b"
              ><img
                width="100%"
                height="100%"
                alt="Register"
                src="data:image/svg+xml,%3Csvg width='64' height='64' viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='%23FFF' fill-rule='nonzero' opacity='.01' d='M0 0h64v64H0z'/%3E%3Cg stroke='%23222' stroke-width='3'%3E%3Cpath d='M51.524 39.007L38.892 51.68c-3.743 3.69-9.813 3.69-13.556 0L6.937 33.543a5.347 5.347 0 0 1 0-7.638L19.44 13.581a5.533 5.533 0 0 1 7.746 0l4.8 4.734'/%3E%3Cpath d='M51.524 39.007l5.399-5.47a5.347 5.347 0 0 0 .14-7.769l-12.36-12.187a5.533 5.533 0 0 0-7.747 0l-9.52 8.982a4.11 4.11 0 0 0-.065 5.913l1.074 1.06a5.852 5.852 0 0 0 8.218 0l2.738-2.7 12.123 12.17z'/%3E%3Cpath d='M31.82 44.659l6.681 6.68m-.872-12.491l6.682 6.681' stroke-linecap='round'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
            /></i>
            <strong class="d-b fs-28 fw-500 c-222 in-h5">Step4</strong>
            <div class="in-pc">
              <strong class="d-b fs-28 fw-500 c-333">Official Dealer</strong>
              <span class="d-b fs-20 lh-15">Work together to achieve goals in your region</span>
            </div>
          </div>
          <div class="right-icon bgs-cover">
            <div class="in-h5">
              <strong class="d-b fs-28 fw-500">Official Dealer</strong>
              <span class="d-b fs-20">Work together to achieve goals in your region</span>
            </div>
          </div>
        </li>
      </ul>
      <div class="form-wrapper p-r">
        <i class="bg-img d-b p-a"></i>
        <div class="form-container p-r z-3">
          <h2 class="ta-c">Register Now</h2>
          <dealerForm />
          <!--#include virtual="/allSiteCommon/newForm/newForm.html"-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import dealerForm from '@/components/dealerForm'
  // import bannerScroll from '@/mixins/bannerScroll.js'

  export default {
    components: {
      dealerForm
    },
    // mixins: [bannerScroll],
    data() {
      return {
        formValidate: {
          name: '',
          mail: '',
          city: '',
          gender: '',
          interest: [],
          date: '',
          time: '',
          desc: ''
        },
        ruleValidate: {
          name: [{ required: true, message: 'The name cannot be empty', trigger: 'blur' }],
          mail: [
            { required: true, message: 'Mailbox cannot be empty', trigger: 'blur' },
            { type: 'email', message: 'Incorrect email format', trigger: 'blur' }
          ],
          city: [{ required: true, message: 'Please select the city', trigger: 'change' }],
          gender: [{ required: true, message: 'Please select gender', trigger: 'change' }],
          interest: [
            { required: true, type: 'array', min: 1, message: 'Choose at least one hobby', trigger: 'change' },
            { type: 'array', max: 2, message: 'Choose two hobbies at best', trigger: 'change' }
          ],
          date: [{ required: true, type: 'date', message: 'Please select the date', trigger: 'change' }],
          time: [{ required: true, type: 'string', message: 'Please select time', trigger: 'change' }],
          desc: [
            { required: true, message: 'Please enter a personal introduction', trigger: 'blur' },
            { type: 'string', min: 20, message: 'Introduce no less than 20 words', trigger: 'blur' }
          ]
        }
      }
    },
    created() {},
    methods: {
      handleSubmit(name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            this.$Message.success('Success!')
          } else {
            this.$Message.error('Fail!')
          }
        })
      },
      handleReset(name) {
        this.$refs[name].resetFields()
      }
    }
  }
</script>

<style scoped lang="scss">
  .main {
    padding-top: 0.76rem;
  }
  .banner-leave-message {
    height: 3.6rem;
    background-image: url('@/assets/images/leave-message/banner.jpg');
  }
  .banner-title {
    font-size: 0.48rem;
  }
  .content {
    padding: 0.64rem 0.56rem 1rem;
  }
  .step-wrapper li {
    position: relative;
    width: 4.4rem;
    height: 2.74rem;
    background-size: cover;
  }
  .step-wrapper li:nth-of-type(1) {
    background-image: url('@/assets/images/leave-message/step-1.jpg');
  }
  .step-wrapper li:nth-of-type(2) {
    background-image: url('@/assets/images/leave-message/step-2.jpg');
  }
  .step-wrapper li:nth-of-type(3) {
    background-image: url('@/assets/images/leave-message/step-3.jpg');
  }
  .step-wrapper li:nth-of-type(4) {
    background-image: url('@/assets/images/leave-message/step-4.jpg');
  }
  .step-wrapper li .img-box {
    width: 0.64rem;
    height: 0.64rem;
  }
  .step-wrapper li strong {
    margin: 0.16rem 0 0.12rem;
  }
  .step-wrapper li .left-cont {
    margin: 0.4rem 0.32rem 0 0.32rem;
  }
  .step-wrapper li .right-icon {
    position: absolute;
    top: 50%;
    right: 0.24rem;
    transform: translateY(-50%);
    width: 0.48rem;
    height: 0.48rem;
    background-image: url("data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23FFF' fill-rule='evenodd' opacity='.848'%3E%3Cpath fill-opacity='.01' d='M0 0v48h48V0z'/%3E%3Cpath d='M44.471 24.019l-2.546 2.544-14.86 14.855h-.002a1.804 1.804 0 1 1-2.548-2.547l-.001-.002 14.86-14.856-14.94-14.935a1.802 1.802 0 1 1 2.55-2.55l17.492 17.485-.005.006z' fill-rule='nonzero'/%3E%3Cpath d='M28.221 24.019l-2.546 2.544-14.86 14.855h-.002a1.804 1.804 0 1 1-2.548-2.547l-.001-.002 14.86-14.856L8.184 9.078a1.802 1.802 0 1 1 2.55-2.55l17.492 17.485-.005.006z' fill-rule='nonzero'/%3E%3C/g%3E%3C/svg%3E");
  }
  .step-wrapper li:nth-of-type(4) .right-icon {
    display: none;
  }
  .form-wrapper {
    margin-top: 0.48rem;
    min-height: 10rem;
    background-color: #fafafa;
  }
  .form-wrapper .bg-img {
    width: 4.95rem;
    height: 9.08rem;
    top: 0.33rem;
    right: 0.6rem;
    background: url('@/assets/images/leave-message/form-bg.png') no-repeat center / cover;
  }
  .form-container {
    padding: 0.64rem 0 0.72rem;
  }
  .form-container h2 {
    margin-bottom: 0.4rem;
    font-size: 0.32rem;
    font-weight: 500;
  }
</style>
